import type { Project } from "../types";

export function buildProjectNameMaps(projects: ReadonlyArray<Project>) {
  return {
    projectTitleById: new Map(projects.map((project) => [project.id, project.name])),
    projectNameByRef: new Map(
      projects.map((project) => [
        String(project.environmentId) + ":" + String(project.id),
        project.name,
      ]),
    ),
  };
}
